module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listing pictureWallList smooth"
  }, [_c('div', {
    attrs: {
      "id": "wallSliderElement"
    }
  }, _vm._l((_vm.listData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item hoverFade",
      on: {
        "click": function($event) {
          _vm.pickItem(item)
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": _vm.imageUrl + '/' + item.image_path
      }
    })])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33d5e096!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Lists/PicturewallList.vue
// module id = 154
// module chunks = 0